export default "__VITE_ASSET__BLczqZma__"